import { useState } from 'react';
import { Modal, TextField, BlockStack } from '@shopify/polaris';

const RejectModal = ({ active, onClose, onReject }) => {
    const [rejectionReason, setRejectionReason] = useState('');
    const [error, setError] = useState('');

    const handleReject = () => {
        if (!rejectionReason.trim()) {
            setError('Rejection reason is required');
            return;
        }
        onReject(rejectionReason);
        setRejectionReason('');
        setError('');
    };

    const handleClose = () => {
        setRejectionReason('');
        setError('');
        onClose();
    };

    return (
        <Modal
            open={active}
            onClose={handleClose}
            title="Reject Cycle Count"
            primaryAction={{
                content: 'Reject',
                destructive: true,
                onAction: handleReject,
            }}
            secondaryActions={[
                {
                    content: 'Cancel',
                    onAction: handleClose,
                },
            ]}
        >
            <Modal.Section>
                <BlockStack gap="400">
                    <TextField
                        label="Rejection Reason"
                        value={rejectionReason}
                        onChange={setRejectionReason}
                        multiline={4}
                        autoComplete="off"
                        error={error}
                        helpText="Provide a reason for rejecting this cycle count"
                    />
                </BlockStack>
            </Modal.Section>
        </Modal>
    );
};

export default RejectModal;
